(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/date/date.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2026 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<div class="input-daterange input-group" ng-show="date.option.value==\'custom\'">',
'  <input type="text" class="form-control" name="start" ng-model="date.model.start" />',
'  <span class="input-group-addon">{{ \'date.to\' | translate }}</span>',
'  <input type="text" class="form-control" name="end"  ng-model="date.model.end"/>',
'</div>',
'<select class="form-control" ng-class="{ \'custom\' : date.option.value==\'custom\'}"',
'  ng-model="date.option" ng-change="date.change()"',
'  ng-options="option as option.label | translate for option in date.options track by option.value">',
'</select>',
'',''].join("\n"));
  }]);
})();